import { useEffect } from "react";


function Seo({
    title,
    description,
    canonical,
    noIndex = false
}) {

    useEffect(() => {

        document.title =
            title
                ? `${title} | Ivan Jörg`
                : "Ivan Jörg | Persönliche Webseite";


        let descriptionMeta =
            document.querySelector(
                'meta[name="description"]'
            );


        if (!descriptionMeta) {

            descriptionMeta =
                document.createElement("meta");

            descriptionMeta.setAttribute(
                "name",
                "description"
            );

            document.head.appendChild(
                descriptionMeta
            );
        }


        descriptionMeta.setAttribute(
            "content",
            description ||
                "Persönliche Webseite von Ivan Jörg."
        );


        let robotsMeta =
            document.querySelector(
                'meta[name="robots"]'
            );


        if (!robotsMeta) {

            robotsMeta =
                document.createElement("meta");

            robotsMeta.setAttribute(
                "name",
                "robots"
            );

            document.head.appendChild(
                robotsMeta
            );
        }


        robotsMeta.setAttribute(
            "content",
            noIndex
                ? "noindex, nofollow"
                : "index, follow"
        );


        let canonicalLink =
            document.querySelector(
                'link[rel="canonical"]'
            );


        if (!canonicalLink) {

            canonicalLink =
                document.createElement("link");

            canonicalLink.setAttribute(
                "rel",
                "canonical"
            );

            document.head.appendChild(
                canonicalLink
            );
        }


        canonicalLink.setAttribute(
            "href",
            canonical ||
                "https://www.irj.ch/"
        );

    }, [
        title,
        description,
        canonical,
        noIndex
    ]);


    return null;
}


export default Seo;